import { render } from "./UsersList.vue?vue&type=template&id=33c52fba&scoped=true"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"

import "./UsersList.vue?vue&type=style&index=0&id=33c52fba&scoped=true&lang=css"

import exportComponent from "/home/circleci/repo/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c52fba"]])

export default __exports__